<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <van-tabbar
      route
      v-model="active"
      active-color="#ffb239"
      inactive-color="#848484"
      :before-change="beforeChange"
      @change="onChange"
    >
      <van-tabbar-item
        v-for="(page, index) in tabList"
        :key="index"
        :to="page.href"
      >
        <span>{{ page.tabTitle }}</span>
        <template #icon="props">
          <img :src="props.active ? page.activeIcon : page.icon" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <div class="winBox" v-if="isShowWin">
      <div class="win_con">
        <span>敬请期待</span>
        <div class="close" @click="isShowWin = false">
          <img src="@/assets/img/close.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: false,
      adid: "123110",
      active: 0,
      isShowWin:false,
      tabList: [
        {
          tabTitle: "首页",
          icon: require("@/assets/img/home_normal.png"),
          activeIcon: require("@/assets/img/home_select.png"),
          href: "/index",
        },
        {
          tabTitle: "礼包",
          icon: require("@/assets/img/gift_normal.png"),
          activeIcon: require("@/assets/img/game_select.png"),
          href: "/gift",
        },
        {
          tabTitle: "积分",
          icon: require("@/assets/img/integral_normal.png"),
          activeIcon: require("@/assets/img/integral_normal.png"),
        },
        {
          tabTitle: "我的",
          icon: require("@/assets/img/user_normal.png"),
          activeIcon: require("@/assets/img/user_select.png"),
          href: "/user",
        },
      ],
    };
  },
  created() {
    // 判断打开链接的终端类型  mobile(移动端)、pc(pc端)
  },
  mounted() {
    let uuid = localStorage.getItem("uuid")
      ? localStorage.getItem("uuid")
      : this.genUUID();
    let MobileDetect = require("mobile-detect");
    let md = new MobileDetect(window.navigator.userAgent);
    let os = md.os() === "iOS" ? "ios" : "android";
    let model = "";
    let str = navigator.userAgent.toLowerCase();
    let ver = str.match(/cpu iphone os (.*?) like mac os/);
    let systemNub = "";
    if (ver && Array.isArray(ver)) {
      systemNub = ver[1].replace(/_/g, ".").split(".")[0];
    }
    if (os == "ios") {
      //ios系统的处理
      model = md.mobile();
    } else if (os == "android") {
      //Android系统的处理
      // os = md.os() + md.version("Android");
      let sss = navigator.userAgent.split(";");
      let i = this.getModel(sss, "Build/");
      if (i > -1) {
        model = sss[i].substring(0, sss[i].indexOf("Build/")).replace("-", "");
      }
    }
    let device = {
      brand: md.mobile(),
      model: model,
      os: os,
      osVersion: systemNub,
      uuid: uuid,
      oaid: "",
      imei: "",
      idfa: "",
      netWorkName: "",
      netWork: "",
      isSimulator: "",
      display: "",
    };
    this.$store.dispatch("getDeviceFuns", JSON.stringify(device));
    localStorage.setItem("device", JSON.stringify(device));
    localStorage.setItem("adid", this.adid);
    this.isRouterAlive = true;
    // this.tokenLogin()
  },
  methods: {
    onChange(index){
      this.isShowWin = false;
    },
    tokenLogin(){
      this.$api.reqData("/api/v1/operation/member/token",{},true).then(
        (res) => {
          if (res.code == 200) {
            
          } else {
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    beforeChange(name){
      if(name == 2){
        this.isShowWin = true
        return false;
      }
      return true
    },
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
    genUUID() {
      let random =
        Math.floor(
          (Math.random() + Math.floor(Math.random() * 9 + 1)) *
            Math.pow(10, 4 - 1)
        ) + "";
      let time = new Date().getTime() + "";
      return this.adid + "H5" + time + "" + random;
    },
    getModel(msg, str) {
      for (let i in msg) {
        if (msg[i].indexOf(str) > 0) {
          return i;
        }
      }
      return -1;
    },
  },
};
</script>

<style >
html,
body {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

/*移动 */

.nut-tab {
  padding: 0 !important;
  font-weight: 500;
}

.nut-tab .nut-tab-title .nut-tab-active .nut-tab-link {
  font-size: 0.36rem;
}

.nav-center {
  height: 0.88rem;
}
@media only screen and (max-width: 1080px) {
  html,
  body {
    /* 设计图750  750px=100vw; 100px = 13.33vw  */
    font-size: 13.33vw;
    /*  */
  }
}
input {
  border: none;
  outline: none;
}
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px white inset;
}
#app {
  width: 100%;
  height: 100%;
  letter-spacing: 0.01rem;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  display: flex;
}


:root {
  --swiper-navigation-size: 22px !important;
  --swiper-theme-color: #f9720d !important;
}

.nut-toast-inner {
  margin-bottom: 2rem;
}

/* 轮播图 */
.nutSwiper,
.nut-swiper-slide img {
  width: 100%;
  border-radius: 0.06rem;
}

.nutSwiper {
  box-sizing: border-box;
}
.swiper {
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.nut-swiper .nut-swiper-pagination .swiper-pagination-bullet {
  color: #fff !important;
  background-color: #fff !important;
  opacity: 1;
}
.nut-swiper .nut-swiper-pagination .swiper-pagination-bullet.active {
  color: #ff913a !important;
  background-color: #ff913a !important;
  opacity: 1;
}


/*积分未开放提示弹窗 */
.winBox {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.win_con {
  width: 5.92rem;
  height: 5.2rem;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  color: #a5a5a5;
  font-size: 16px;
}
.close {
  position: absolute;
  top: 0;
  right: 0;
  width: 0.9rem;
  height: 0.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close img {
  width: 0.32rem;
}
/* 分页样式 */
.van-pagination__item--active{
  background-color: #ff913a;
}
.van-pagination__item{
  color: #ff913a;
  height: 34px;
  min-width: 32px;
}
.van-pagination__item--active{
  color: #fff;
}
p img {
  width: 6.2rem !important;
  height: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue